/**
 * FL-132: 陸送員スケジュールデモデータ
 *
 * 2025年7月22日（火曜日）を中心とした週間スケジュールデータ
 * - 7/22当日: アクティブな配車状況
 * - 週間パターン: 勤務シフト・休暇・案件アサイン状況
 */

import { LandTransporter } from '../../types';

/**
 * デモ陸送員マスターデータ
 */
export const DEMO_TRANSPORTERS: Partial<LandTransporter>[] = [
  // 陸送員A（ベテラン・リーダー）
  {
    id: 'lt-driver-a-001',
    name: '田中 太郎',
    phone: '090-1234-5678',
    address: '東京都大田区蒲田1-1-1',
    status: 'Available',
    drivableVehicleTypes: ['普通車', 'SUV', '軽自動車'],
    workingDays: {
      monday: { startTime: '08:00', endTime: '18:00' },
      tuesday: { startTime: '08:00', endTime: '18:00' },
      wednesday: { startTime: '08:00', endTime: '18:00' },
      thursday: { startTime: '08:00', endTime: '18:00' },
      friday: { startTime: '08:00', endTime: '18:00' },
      saturday: { startTime: '09:00', endTime: '15:00' },
      sunday: null,
    },
    hasLicenseForLargeVehicles: true,
    canWorkNightShift: false,
    canWorkLongDistance: true,
    hasTemporaryLicense: true,
    isATOnly: false,
  },

  // 陸送員B（中堅・個人宅対応得意）
  {
    id: 'lt-driver-b-001',
    name: '佐藤 花子',
    phone: '090-2345-6789',
    address: '神奈川県横浜市港北区新横浜2-2-2',
    status: 'Available',
    drivableVehicleTypes: ['普通車', '軽自動車'],
    workingDays: {
      monday: { startTime: '09:00', endTime: '17:00' },
      tuesday: { startTime: '09:00', endTime: '17:00' },
      wednesday: { startTime: '09:00', endTime: '17:00' },
      thursday: { startTime: '09:00', endTime: '17:00' },
      friday: { startTime: '09:00', endTime: '17:00' },
      saturday: null,
      sunday: null,
    },
    hasLicenseForLargeVehicles: false,
    canWorkNightShift: false,
    canWorkLongDistance: false,
    hasTemporaryLicense: false,
    isATOnly: true,
  },

  // 陸送員C（新人・研修中）
  {
    id: 'lt-driver-c-001',
    name: '鈴木 次郎',
    phone: '090-3456-7890',
    address: '埼玉県さいたま市浦和区高砂3-3-3',
    status: 'Available',
    drivableVehicleTypes: ['普通車', '軽自動車'],
    workingDays: {
      monday: { startTime: '08:30', endTime: '17:30' },
      tuesday: { startTime: '08:30', endTime: '17:30' },
      wednesday: { startTime: '08:30', endTime: '17:30' },
      thursday: { startTime: '08:30', endTime: '17:30' },
      friday: { startTime: '08:30', endTime: '17:30' },
      saturday: { startTime: '09:00', endTime: '13:00' },
      sunday: null,
    },
    hasLicenseForLargeVehicles: false,
    canWorkNightShift: false,
    canWorkLongDistance: false,
    hasTemporaryLicense: false,
    isATOnly: false,
  },

  // 陸送員D（夜勤シフト・長距離対応）
  {
    id: 'lt-driver-d-001',
    name: '高橋 三郎',
    phone: '090-4567-8901',
    address: '千葉県市川市南八幡4-4-4',
    status: 'Available',
    drivableVehicleTypes: ['普通車', 'SUV', '軽自動車'],
    workingDays: {
      monday: { startTime: '20:00', endTime: '05:00' },
      tuesday: { startTime: '20:00', endTime: '05:00' },
      wednesday: { startTime: '20:00', endTime: '05:00' },
      thursday: { startTime: '20:00', endTime: '05:00' },
      friday: { startTime: '20:00', endTime: '05:00' },
      saturday: null,
      sunday: null,
    },
    hasLicenseForLargeVehicles: true,
    canWorkNightShift: true,
    canWorkLongDistance: true,
    hasTemporaryLicense: true,
    isATOnly: false,
  },

  // 陸送員E（ベテラン・高級車対応）
  {
    id: 'lt-driver-e-001',
    name: '渡辺 五郎',
    phone: '090-5678-9012',
    address: '東京都世田谷区用賀5-5-5',
    status: 'Available',
    drivableVehicleTypes: ['普通車', 'SUV', '軽自動車'],
    workingDays: {
      monday: { startTime: '10:00', endTime: '19:00' },
      tuesday: { startTime: '10:00', endTime: '19:00' },
      wednesday: { startTime: '10:00', endTime: '19:00' },
      thursday: { startTime: '10:00', endTime: '19:00' },
      friday: { startTime: '10:00', endTime: '19:00' },
      saturday: { startTime: '10:00', endTime: '16:00' },
      sunday: null,
    },
    hasLicenseForLargeVehicles: true,
    canWorkNightShift: false,
    canWorkLongDistance: true,
    hasTemporaryLicense: true,
    isATOnly: false,
  },

  // 陸送員F（パートタイム・午前中のみ）
  {
    id: 'lt-driver-f-001',
    name: '小林 美香',
    phone: '090-6789-0123',
    address: '東京都練馬区石神井町6-6-6',
    status: 'Available',
    drivableVehicleTypes: ['普通車', '軽自動車'],
    workingDays: {
      monday: { startTime: '09:00', endTime: '13:00' },
      tuesday: { startTime: '09:00', endTime: '13:00' },
      wednesday: { startTime: '09:00', endTime: '13:00' },
      thursday: { startTime: '09:00', endTime: '13:00' },
      friday: { startTime: '09:00', endTime: '13:00' },
      saturday: null,
      sunday: null,
    },
    hasLicenseForLargeVehicles: false,
    canWorkNightShift: false,
    canWorkLongDistance: false,
    hasTemporaryLicense: false,
    isATOnly: true,
  },

  // 陸送員G（休暇中）
  {
    id: 'lt-driver-g-001',
    name: '伊藤 七郎',
    phone: '090-7890-1234',
    address: '神奈川川崎市中原区小杉町7-7-7',
    status: 'Unavailable',
    drivableVehicleTypes: ['普通車', 'SUV'],
    workingDays: {
      monday: null, // 夏季休暇
      tuesday: null,
      wednesday: null,
      thursday: null,
      friday: null,
      saturday: null,
      sunday: null,
    },
    hasLicenseForLargeVehicles: true,
    canWorkNightShift: false,
    canWorkLongDistance: true,
    hasTemporaryLicense: true,
    isATOnly: false,
  },

  // 陸送員H（研修参加）
  {
    id: 'lt-driver-h-001',
    name: '山田 八郎',
    phone: '090-8901-2345',
    address: '埼玉県川口市本町8-8-8',
    status: 'Unavailable',
    drivableVehicleTypes: ['普通車'],
    workingDays: {
      monday: { startTime: '09:00', endTime: '18:00' },
      tuesday: { startTime: '09:00', endTime: '18:00' },
      wednesday: { startTime: '09:00', endTime: '18:00' },
      thursday: { startTime: '09:00', endTime: '18:00' },
      friday: null, // 研修参加
      saturday: null,
      sunday: null,
    },
    hasLicenseForLargeVehicles: false,
    canWorkNightShift: false,
    canWorkLongDistance: false,
    hasTemporaryLicense: false,
    isATOnly: false,
  },
];

/**
 * 週間スケジュールデータ（7月7日〜7月13日）
 */
export const WEEKLY_SCHEDULE = {
  // 月曜日（7/7）
  '2025-07-07': {
    date: '2025-07-07',
    dayOfWeek: '月曜日',
    totalCases: 6,
    activeTransporters: [
      {
        transporterId: 'lt-driver-a-001',
        name: '田中 太郎',
        shift: '日勤',
        workingHours: { start: '08:00', end: '18:00' },
        assignedCases: ['case-mon-001', 'case-mon-002'],
        status: 'active',
        caseCount: 2,
        estimatedWorkload: 75, // パーセント
      },
      {
        transporterId: 'lt-driver-b-001',
        name: '佐藤 花子',
        shift: '日勤',
        workingHours: { start: '09:00', end: '17:00' },
        assignedCases: ['case-mon-003'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 60,
      },
      {
        transporterId: 'lt-driver-c-001',
        name: '鈴木 次郎',
        shift: '日勤',
        workingHours: { start: '08:30', end: '17:30' },
        assignedCases: ['case-mon-004'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 50,
      },
      {
        transporterId: 'lt-driver-e-001',
        name: '渡辺 五郎',
        shift: '日勤',
        workingHours: { start: '10:00', end: '19:00' },
        assignedCases: ['case-mon-005', 'case-mon-006'],
        status: 'active',
        caseCount: 2,
        estimatedWorkload: 80,
      },
      {
        transporterId: 'lt-driver-f-001',
        name: '小林 美香',
        shift: '午前のみ',
        workingHours: { start: '09:00', end: '13:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
    ],
    offTransporters: [
      { transporterId: 'lt-driver-d-001', name: '高橋 三郎', reason: '夜勤シフト' },
      { transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' },
      { transporterId: 'lt-driver-h-001', name: '山田 八郎', reason: '通常勤務' },
    ],
  },

  // 火曜日（7/8）
  '2025-07-08': {
    date: '2025-07-08',
    dayOfWeek: '火曜日',
    totalCases: 7,
    activeTransporters: [
      {
        transporterId: 'lt-driver-a-001',
        name: '田中 太郎',
        shift: '日勤',
        workingHours: { start: '08:00', end: '18:00' },
        assignedCases: ['case-tue-001', 'case-tue-002', 'case-tue-003'],
        status: 'active',
        caseCount: 3,
        estimatedWorkload: 90,
      },
      {
        transporterId: 'lt-driver-b-001',
        name: '佐藤 花子',
        shift: '日勤',
        workingHours: { start: '09:00', end: '17:00' },
        assignedCases: ['case-tue-004'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 55,
      },
      {
        transporterId: 'lt-driver-c-001',
        name: '鈴木 次郎',
        shift: '日勤',
        workingHours: { start: '08:30', end: '17:30' },
        assignedCases: ['case-tue-005'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 45,
      },
      {
        transporterId: 'lt-driver-e-001',
        name: '渡辺 五郎',
        shift: '日勤',
        workingHours: { start: '10:00', end: '19:00' },
        assignedCases: ['case-tue-006', 'case-tue-007'],
        status: 'active',
        caseCount: 2,
        estimatedWorkload: 85,
      },
      {
        transporterId: 'lt-driver-f-001',
        name: '小林 美香',
        shift: '午前のみ',
        workingHours: { start: '09:00', end: '13:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
      {
        transporterId: 'lt-driver-h-001',
        name: '山田 八郎',
        shift: '日勤',
        workingHours: { start: '09:00', end: '18:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
    ],
    offTransporters: [
      { transporterId: 'lt-driver-d-001', name: '高橋 三郎', reason: '夜勤シフト' },
      { transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' },
    ],
  },

  // 水曜日（7/9）
  '2025-07-09': {
    date: '2025-07-09',
    dayOfWeek: '水曜日',
    totalCases: 5,
    activeTransporters: [
      {
        transporterId: 'lt-driver-a-001',
        name: '田中 太郎',
        shift: '日勤',
        workingHours: { start: '08:00', end: '18:00' },
        assignedCases: ['case-wed-001', 'case-wed-002'],
        status: 'active',
        caseCount: 2,
        estimatedWorkload: 70,
      },
      {
        transporterId: 'lt-driver-b-001',
        name: '佐藤 花子',
        shift: '日勤',
        workingHours: { start: '09:00', end: '17:00' },
        assignedCases: ['case-wed-003'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 65,
      },
      {
        transporterId: 'lt-driver-c-001',
        name: '鈴木 次郎',
        shift: '日勤',
        workingHours: { start: '08:30', end: '17:30' },
        assignedCases: ['case-wed-004'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 55,
      },
      {
        transporterId: 'lt-driver-e-001',
        name: '渡辺 五郎',
        shift: '日勤',
        workingHours: { start: '10:00', end: '19:00' },
        assignedCases: ['case-wed-005'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 60,
      },
      {
        transporterId: 'lt-driver-f-001',
        name: '小林 美香',
        shift: '午前のみ',
        workingHours: { start: '09:00', end: '13:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
      {
        transporterId: 'lt-driver-h-001',
        name: '山田 八郎',
        shift: '日勤',
        workingHours: { start: '09:00', end: '18:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
    ],
    offTransporters: [
      { transporterId: 'lt-driver-d-001', name: '高橋 三郎', reason: '夜勤シフト' },
      { transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' },
    ],
  },

  // 木曜日（7/10）
  '2025-07-10': {
    date: '2025-07-10',
    dayOfWeek: '木曜日',
    totalCases: 6,
    activeTransporters: [
      {
        transporterId: 'lt-driver-a-001',
        name: '田中 太郎',
        shift: '日勤',
        workingHours: { start: '08:00', end: '18:00' },
        assignedCases: ['case-thu-001', 'case-thu-002'],
        status: 'active',
        caseCount: 2,
        estimatedWorkload: 80,
      },
      {
        transporterId: 'lt-driver-b-001',
        name: '佐藤 花子',
        shift: '日勤',
        workingHours: { start: '09:00', end: '17:00' },
        assignedCases: ['case-thu-003'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 70,
      },
      {
        transporterId: 'lt-driver-c-001',
        name: '鈴木 次郎',
        shift: '日勤',
        workingHours: { start: '08:30', end: '17:30' },
        assignedCases: ['case-thu-004'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 60,
      },
      {
        transporterId: 'lt-driver-d-001',
        name: '高橋 三郎',
        shift: '夜勤',
        workingHours: { start: '20:00', end: '05:00' },
        assignedCases: ['case-thu-005'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 50,
      },
      {
        transporterId: 'lt-driver-e-001',
        name: '渡辺 五郎',
        shift: '日勤',
        workingHours: { start: '10:00', end: '19:00' },
        assignedCases: ['case-thu-006'],
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 65,
      },
      {
        transporterId: 'lt-driver-f-001',
        name: '小林 美香',
        shift: '午前のみ',
        workingHours: { start: '09:00', end: '13:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
      {
        transporterId: 'lt-driver-h-001',
        name: '山田 八郎',
        shift: '日勤',
        workingHours: { start: '09:00', end: '18:00' },
        assignedCases: [],
        status: 'standby',
        caseCount: 0,
        estimatedWorkload: 0,
      },
    ],
    offTransporters: [{ transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' }],
  },

  // 火曜日（7/22）- デモ当日
  '2025-07-22': {
    date: '2025-07-22',
    dayOfWeek: '火曜日',
    totalCases: 8, // TODAY_CASESの数と一致
    activeTransporters: [
      {
        transporterId: 'lt-driver-a-001',
        name: '田中 太郎',
        shift: '日勤',
        workingHours: { start: '08:00', end: '18:00' },
        assignedCases: ['case-today-001'], // 配送中
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 85,
      },
      {
        transporterId: 'lt-driver-b-001',
        name: '佐藤 花子',
        shift: '日勤',
        workingHours: { start: '09:00', end: '17:00' },
        assignedCases: ['case-today-002'], // 配車済み
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 75,
      },
      {
        transporterId: 'lt-driver-c-001',
        name: '鈴木 次郎',
        shift: '日勤',
        workingHours: { start: '08:30', end: '17:30' },
        assignedCases: [],
        status: 'available',
        caseCount: 0,
        estimatedWorkload: 30, // 午前中の予備案件対応
      },
      {
        transporterId: 'lt-driver-d-001',
        name: '高橋 三郎',
        shift: '夜勤',
        workingHours: { start: '20:00', end: '05:00' },
        assignedCases: [],
        status: 'available',
        caseCount: 0,
        estimatedWorkload: 0, // 夜勤なので日中は休憩
      },
      {
        transporterId: 'lt-driver-e-001',
        name: '渡辺 五郎',
        shift: '日勤',
        workingHours: { start: '10:00', end: '19:00' },
        assignedCases: ['case-today-004'], // 配車済み
        status: 'active',
        caseCount: 1,
        estimatedWorkload: 80,
      },
      {
        transporterId: 'lt-driver-f-001',
        name: '小林 美香',
        shift: '午前のみ',
        workingHours: { start: '09:00', end: '13:00' },
        assignedCases: [],
        status: 'available',
        caseCount: 0,
        estimatedWorkload: 40, // 午前中案件対応可能
      },
    ],
    offTransporters: [
      { transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' },
      { transporterId: 'lt-driver-h-001', name: '山田 八郎', reason: '研修参加' },
    ],
    unassignedCases: [
      'case-today-003', // 緊急案件
      'case-today-005', // 車検切れ対応
      'case-today-006', // 夕方配送
      'case-today-007', // 緊急追加
      'case-today-008', // 週末前最終
    ],
    workloadSummary: {
      totalCapacity: 100,
      currentUtilization: 65,
      availableCapacity: 35,
      urgentCases: 2,
      scheduledOptimization: true, // AI配車最適化予定
    },
  },

  // 土曜日（7/12）
  '2025-07-12': {
    date: '2025-07-12',
    dayOfWeek: '土曜日',
    totalCases: 3,
    activeTransporters: [
      {
        transporterId: 'lt-driver-a-001',
        name: '田中 太郎',
        shift: '土曜日勤',
        workingHours: { start: '09:00', end: '15:00' },
        assignedCases: ['case-future-001'],
        status: 'scheduled',
        caseCount: 1,
        estimatedWorkload: 70,
      },
      {
        transporterId: 'lt-driver-c-001',
        name: '鈴木 次郎',
        shift: '土曜日勤',
        workingHours: { start: '09:00', end: '13:00' },
        assignedCases: [],
        status: 'scheduled',
        caseCount: 0,
        estimatedWorkload: 0,
      },
      {
        transporterId: 'lt-driver-e-001',
        name: '渡辺 五郎',
        shift: '土曜日勤',
        workingHours: { start: '10:00', end: '16:00' },
        assignedCases: [],
        status: 'scheduled',
        caseCount: 0,
        estimatedWorkload: 0,
      },
    ],
    offTransporters: [
      { transporterId: 'lt-driver-b-001', name: '佐藤 花子', reason: '土日休み' },
      { transporterId: 'lt-driver-d-001', name: '高橋 三郎', reason: '土日休み' },
      { transporterId: 'lt-driver-f-001', name: '小林 美香', reason: '土日休み' },
      { transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' },
      { transporterId: 'lt-driver-h-001', name: '山田 八郎', reason: '土日休み' },
    ],
  },

  // 日曜日（7/13）
  '2025-07-13': {
    date: '2025-07-13',
    dayOfWeek: '日曜日',
    totalCases: 0, // 日曜は基本的に案件なし
    activeTransporters: [],
    offTransporters: [
      { transporterId: 'lt-driver-a-001', name: '田中 太郎', reason: '日曜休み' },
      { transporterId: 'lt-driver-b-001', name: '佐藤 花子', reason: '土日休み' },
      { transporterId: 'lt-driver-c-001', name: '鈴木 次郎', reason: '日曜休み' },
      { transporterId: 'lt-driver-d-001', name: '高橋 三郎', reason: '土日休み' },
      { transporterId: 'lt-driver-e-001', name: '渡辺 五郎', reason: '日曜休み' },
      { transporterId: 'lt-driver-f-001', name: '小林 美香', reason: '土日休み' },
      { transporterId: 'lt-driver-g-001', name: '伊藤 七郎', reason: '夏季休暇' },
      { transporterId: 'lt-driver-h-001', name: '山田 八郎', reason: '土日休み' },
    ],
  },
} as const;

/**
 * デモスケジュールデータの統計情報
 */
export const DEMO_SCHEDULE_STATS = {
  TOTAL_TRANSPORTERS: DEMO_TRANSPORTERS.length,
  ACTIVE_TUESDAY: WEEKLY_SCHEDULE['2025-07-22'].activeTransporters.length,
  OFF_TUESDAY: WEEKLY_SCHEDULE['2025-07-22'].offTransporters.length,
  UNASSIGNED_CASES_TUESDAY: WEEKLY_SCHEDULE['2025-07-22'].unassignedCases.length,
  WORKLOAD_UTILIZATION_TUESDAY: WEEKLY_SCHEDULE['2025-07-22'].workloadSummary.currentUtilization,
  WEEKLY_CASE_DISTRIBUTION: {
    MONDAY: WEEKLY_SCHEDULE['2025-07-07'].totalCases,
    TUESDAY: WEEKLY_SCHEDULE['2025-07-08'].totalCases,
    WEDNESDAY: WEEKLY_SCHEDULE['2025-07-09'].totalCases,
    THURSDAY: WEEKLY_SCHEDULE['2025-07-10'].totalCases,
    TUESDAY_DEMO: WEEKLY_SCHEDULE['2025-07-22'].totalCases,
    SATURDAY: WEEKLY_SCHEDULE['2025-07-12'].totalCases,
    SUNDAY: WEEKLY_SCHEDULE['2025-07-13'].totalCases,
  },
} as const;

export const DEMO_SCHEDULES = {
  TRANSPORTERS: DEMO_TRANSPORTERS,
  WEEKLY: WEEKLY_SCHEDULE,
  STATS: DEMO_SCHEDULE_STATS,
} as const;

export default DEMO_SCHEDULES;
